import { FC } from 'react';
import { MainStyled } from './style';

const Main: FC = ({ children, ...restProps }) => <MainStyled {...restProps}>{children}</MainStyled>;

export default Main;
